import { mdiStar, mdiStarOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { IconButton } from '@mui/material';
import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { updateFavourites } from '../../../../redux/user/sliceUserSettings';
import { vars } from '../../../../Theme';

/**
 * Type of IconButton that allows a user to toggle a project's favourite state.
 */
export default (props: IProjectFavouriteButtonProps) => {
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'projectSelectionView' });

    /** Deconstruct props. */
    const { favourite, replicaId } = props;

    /**
     * Toggles the project's favourite state.
     */
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        return dispatch(updateFavourites({ id: replicaId, favourite: !favourite }));
    };

    /** Button title text. */
    const title = t(favourite ? 'removeFavourite' : 'makeFavourite');

    return (
        <IconButton
            onClick={handleClick}
            title={title}
            sx={{ color: favourite ? vars.brandYellow : vars.font }}
        >
            <Icon path={favourite ? mdiStar : mdiStarOutline} size={1} />
        </IconButton>
    );
};

/**
 * Interface that describes the properties needed for the ProjectFavouriteButton component.
 */
export interface IProjectFavouriteButtonProps {
    /** Project ReplicaId. */
    replicaId: string;

    /** Current Project Favourite state. */
    favourite: boolean;
}
